import React, { useState, useEffect } from 'react';
import {
    Grid,
    Typography,
} from '@mui/material';
import Routes from '../../routes';
import Loading from '../Loading';
import {
    CommonModal,
    PrimaryButton,
    SecondaryButton,
} from '../Common';
import { trakrefFontFamily, } from '../../utils';
import toast from 'react-hot-toast';

export function ReactivateLocation(props) {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(false);
    }, []);


    async function ReactivateLocation(e) {
        e.stopPropagation();

        const requestData = {
            id: props.id,
        };
        try {
            const response = await fetch(Routes.Location.ReactivateLocation(), {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(requestData)
            });

            if (response.ok) {
                toast.success('The location has been successfully reactivated.', { duration: 6000 });
                props.saveCallback();
            } else {
                toast.error('There was an error saving the location', { duration: 6000 });
            }
        } catch (error) {
            toast.error('There was an error saving the location', { duration: 6000 });
            console.error(error);
        }
    }

    return loading ? (
        <div>
            <Loading />
        </div>
    ) : (
        <CommonModal
            open={props.open}
            close={props.close}
            renderCloseIcon={false}
        >
            <Grid container width={499} >
                <Grid item xs={12} lg={12} mb={2} pt={2} align='center'>
                    <Typography sx={{ padding: '1% 0%', fontSize: 22, fontWeight: 400, color: '#1A173B', fontFamily: trakrefFontFamily }}>
                        Reactivate Location?
                    </Typography>
                </Grid>

                <Grid item xs={12} align="center" marginBottom={2}>
                    <PrimaryButton
                        useLargeButton
                        buttonText={'Reactivate Location'}
                        onClick={ReactivateLocation}
                        width={65}
                    />
                </Grid>
                <Grid item xs={12} align="center" marginBottom={5}>
                    <SecondaryButton
                        useLargeButton
                        buttonText={'Cancel'}
                        onClick={props.close()}
                        width={65}
                    />
                </Grid>
            </Grid>
        </CommonModal>
    );

};

export default ReactivateLocation;